import { Box, DialogActions, DialogTitle, Typography, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const RiskAssessmentEquipmentTableHeadCell = muiStyled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const RiskAssessmentEquipmentColumnTitleTypography = muiStyled(Typography)(() => ({
  fontFamily: 'Roboto',
  fontWeight: 700,
  fontSize: '1.4rem',
  lineHeight: '16px',
  letterSpacing: '0.5px',
  color: '#425265',
}));

export const cellStyles = {
  backgroundColor: 'rgba(236,239,243,255)',
  border: '1px solid rgba(224, 224, 224, 224)',
  whiteSpace: 'nowrap',
  padding: '8px',
};

export const Header = muiStyled(DialogTitle)(() => ({
  padding: '3.2rem',
  paddingBottom: '2.4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const TitleText = muiStyled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '2rem',
  lineHeight: 'normal',
  color: abyssColors.primary[500],
}));

export const Footer = muiStyled(DialogActions)(() => ({
  height: '6.2rem',
  padding: '1.6rem 3.2rem',
  borderTop: '1px solid rgba(101, 130, 164, 0.20)',
  gap: '1.2rem',
}));
